<template>
  <Modal
    v-model="showModal"
    footer-hide
    class-name="company-detail-modal no-padding _close"
    class="pos-relative"
    width="70">
    <Row>
      <i-col :xs="24" :sm="12" class="company-info" v-if="company">
        <div class="cover-photo pos-relative clickable" @click="handleTechProviderPage(company.slug)">
          <div class="overlay"></div>
          <img class="company-cover centered" :alt="company.name" :src="(company.cover_photo)? company.cover_photo : require('@/assets/images/default-cover-photo.jpg')" width="100%"/>
          <div class="company-name">{{company.name}}</div>
        </div>
        <div class="company-desc padding-20" v-if="company.description">
          <h4><Icon type="md-menu" :size="17"/> &nbsp; Description</h4>
          <p v-html="company.description"></p>
        </div>
        <div class="company-categories padding-20">
          <h4><Icon type="md-apps" :size="17"/> &nbsp; Categories</h4>
          <span v-for="(cat, idx) in company.categories" :key="idx"><Icon type="logo-buffer" /> {{ cat }}</span>
          <p v-if="company.categories && company.categories.length < 1"> no categories </p>
        </div>
      </i-col>
      <i-col :xs="24" :sm="12" v-if="company" class="pos-relative">
        <div style="width: 100%" class="fullheight" v-if="company.longitude && company.latitude">
          <MglMap :accessToken="mapboxAccessToken" :mapStyle.sync="mapStyle" id="vue-mapbox-mglmap" @load="onMapLoaded" :zoom="15" :center="[company.longitude, company.latitude]" style="height:100% !important;">
            <MglNavigationControl position="bottom-right" />
            <MglFullscreenControl position="bottom-right" />
            <MglMarker :coordinates="[company.longitude, company.latitude]" color="red" />
          </MglMap>
        </div>
        <div v-else-if="company.address" style="width: 100%" class="fullheight" >
          <MglMap :accessToken="mapboxAccessToken" :mapStyle.sync="mapStyle" id="vue-mapbox-mglmap" @load="onMapLoaded" :zoom="15" :center="coordinates" style="height:100% !important;">
            <MglNavigationControl position="bottom-right" />
            <MglFullscreenControl position="bottom-right" />
          </MglMap>
        </div>
        <p v-else class="centered text-center">No address provided</p>
      </i-col>
    </Row>
    <Spin size="large" fix v-if="isLoading"></Spin>
  </Modal>
</template>

<script>
import { fetchCompanyBySlug } from '@/services/companies'
import { MglMap, MglNavigationControl, MglMarker, MglFullscreenControl } from 'vue-mapbox'
import axios from 'axios'
import mapboxgl from 'mapbox-gl'

export default {
  components: {
    MglMap,
    MglNavigationControl,
    MglFullscreenControl,
    MglMarker
  },

  data () {
    return {
      showModal: false,
      company: null,
      isLoading: false,
      mapboxAccessToken: process.env.VUE_APP_MAPBOX_API_KEY,
      mapStyle: 'mapbox://styles/mapbox/streets-v11',
      coordinates: [0, 0]
    }
  },

  created () {
    this.mapbox = null
  },

  methods: {
    onMapLoaded (event) {
      this.map = event.map
      new mapboxgl.Marker().setLngLat(this.coordinates).addTo(this.map)
    },

    openModal (slug) {
      this.showModal = true
      if (slug) this.getCompanyBySlug(slug)
    },

    getCompanyBySlug (slug) {
      this.isLoading = true
      fetchCompanyBySlug(slug).then(async res => {
        if (res.data.latitude === null && res.data.longitude === null) {
          if (res.data.address) {
            this.coordinates = await this.getMapCoordinates(res.data.address)
          }
        }
        this.company = res.data
        this.isLoading = false
      }).catch(err => {
        console.log('Failed to fetch company by slug: ', err)
        this.isLoading = false
      })
    },

    async getMapCoordinates (add) {
      const response = await axios.get(`${process.env.VUE_APP_MAPBOX_API_URL}${add}.json?access_token=${this.mapboxAccessToken}`)
      return response.data.features[0].center
    },

    handleTechProviderPage (slug) {
      window.location = this.$router.resolve({
        name: 'company',
        params: {
          slug: slug
        },
        query: {}
      }).href
    }
  }
}
</script>

<style lang="scss" scoped>
.company-detail-modal {
  .company-info {
    .cover-photo {
      width: 100%;
      overflow: hidden;
      height: 200px;
      .company-name {
        position: absolute;
        color: #ffffff;
        z-index: 9;
        padding: 20px;
        font-weight: bold;
        bottom: 0px;
      }
    }
    .company-desc {
      height: 200px;
      padding-bottom: 0px;
      p {
        height: calc(100% - 21px);
        overflow: auto;
        overflow-y: scroll;
        overflow-x: hidden;
      }
    }
    .company-categories {
      span {
        padding: 0px 10px;
        display: block;
      }
    }
  }
}
</style>
<style lang="scss">
.company-detail-modal {
  .ivu-modal {
    .ivu-modal-content {
      position: relative;
      min-height: 450px;
      #map {
        height: 100% !important;
      }
    }
  }
}
</style>
